const intToBoolean = [
  { value: true, config: "1" },
  { value: false, config: "0" },
];

const question1List = [
  { value: "0", config: "", label: "select_a_question" },
  { value: "1", config: "1", label: "quest1_1" },
  { value: "2", config: "2", label: "quest1_2" },
  { value: "3", config: "3", label: "quest1_3" },
  { value: "4", config: "4", label: "quest1_4" },
  { value: "5", config: "5", label: "quest1_5" },
  { value: "6", config: "6", label: "quest1_6" },
  { value: "7", config: "7", label: "quest1_7" },
  { value: "8", config: "8", label: "quest1_8" },
  { value: "9", config: "9", label: "quest1_9" },
];

const question2List = [
  { value: "0", config: "", label: "select_a_question" },
  { value: "1", config: "1", label: "quest2_1" },
  { value: "2", config: "2", label: "quest2_2" },
  { value: "3", config: "3", label: "quest2_3" },
  { value: "4", config: "4", label: "quest2_4" },
  { value: "5", config: "5", label: "quest2_5" },
  { value: "6", config: "6", label: "quest2_6" },
  { value: "7", config: "7", label: "quest2_7" },
  { value: "8", config: "8", label: "quest2_8" },
];

const regionList = [
  {
    value: "Africa",
    config: "ZAF",
    label: "coun_af",
  },
  {
    value: "Asia",
    config: "THA",
    label: "coun_as",
  },
  {
    value: "Australia",
    config: "AUS",
    label: "coun_au",
  },
  {
    value: "Europe",
    config: "GER",
    label: "coun_eu",
  },
  {
    value: "India",
    config: "IND",
    label: "coun_in",
  },
  {
    value: "Korea",
    config: "KOR",
    label: "coun_ko",
  },
  {
    value: "Israel",
    config: "ISR",
    label: "coun_is",
  },
  {
    value: "Malaysia",
    config: "MYS",
    label: "coun_ma",
  },
  {
    value: "Mexica",
    config: "MEX",
    label: "coun_mx",
  },
  {
    value: "Sussia",
    config: "RUS",
    label: "coun_ru",
  },
  {
    value: "Singapore",
    config: "SGP",
    label: "coun_si",
  },
  {
    value: "South America",
    config: "BRA",
    label: "coun_sa",
  },
  {
    value: "Taiwan",
    config: "TWN",
    label: "coun_ta",
  },
  {
    value: "Hong Kong",
    config: "HKG",
    label: "coun_hk",
  },
  {
    value: "Vienam",
    config: "VNM",
    label: "coun_vn",
  },
  {
    value: "New Zealand",
    config: "NZL",
    label: "coun_nz",
  },
  {
    value: "Middle East(Algeria/syria/Yemen)",
    config: "DZA",
    label: "coun_md_1",
  },
  {
    value: "Midel East(Iran/Lebanon/Qatar)",
    config: "QAT",
    label: "coun_md_2",
  },
  {
    value: "Middle East(Turkey/Egypt/tunisia/Kuwait)",
    config: "TUR",
    label: "coun_md_3",
  },
  {
    value: "Middle East(Saudi Arabia)",
    config: "SAU",
    label: "coun_md_4",
  },
  {
    value: "Middle East(United Arab Emirates)",
    config: "ARE",
    label: "coun_md_5",
  },
  {
    value: "Canada",
    config: "CAN",
    label: "coun_ca",
  },
  {
    value: "Japan",
    config: "JPN",
    label: "coun_jp",
  },
  {
    value: "North America",
    config: "USA",
    label: "coun_na",
  },
  {
    value: "China",
    config: "CHN",
    label: "coun_ch",
  },
];

const dniEncrypt = "dniEncrypt";
const pwdEncrypt = "pwdEncrypt";

export const commonMapping = {
  intToBoolean,
  dniEncrypt,
  pwdEncrypt,
  question1List,
  question2List,
  regionList,
};

export default commonMapping;
